export enum BoardFirstLevelPage {
  OVERVIEW = 'overview',
  DETAILS = 'details',
  DIGITAL = 'digital',
  WEEK_OVERVIEW = 'week',
  ATTENDANCE = 'attendance',
  ATTENDANCE_EXPORT = 'export-attendance',
  ATTENDANCE_EXPORT_HISTORY = 'export-attendance-history',
  KPF_MANAGEMENT = 'kpf-management',
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class BoardRoutes {
  public static overview = `/${BoardFirstLevelPage.OVERVIEW}`;
  public static digital = `/${BoardFirstLevelPage.DIGITAL}`;
  public static details = `/${BoardFirstLevelPage.DETAILS}`;
  public static weekOverview = `/${BoardFirstLevelPage.WEEK_OVERVIEW}`;
  public static attendance = `/${BoardFirstLevelPage.ATTENDANCE}`;
  public static attendanceExport = `/${BoardFirstLevelPage.ATTENDANCE_EXPORT}`;
  public static attendanceExportHistory = `/${BoardFirstLevelPage.ATTENDANCE_EXPORT_HISTORY}`;
  public static kpfManagement = `/${BoardFirstLevelPage.KPF_MANAGEMENT}`;
}
